import { useContext } from "react";
import {
  DetailModalContext,
  type DetailModalContextValue,
  type DetailType,
} from "@/components/detail-views/DetailModalContext";

export function useDetailModal(): DetailModalContextValue {
  const context = useContext(DetailModalContext);
  if (!context) {
    throw new Error("useDetailModal must be used within a DetailModalProvider");
  }
  return context;
}

export type { DetailType };
